<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YkrsVA/tc-custom/9781625846365.jpg?1728851738598" alt="This image is the cover for the book Hidden History of New Jersey at War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of New Jersey at War
      </h1>
      <p class="bookDescription body article font2">
        <p>The Garden State has made innumerable contributions to our nation's military history, on both battlefield and homefront, but many of those stories remain hidden within the larger national narrative. Perhaps the most crucial one-day battle of the Revolution was fought in Monmouth County, and New Jersey officers engineered the conquest of California in the Mexican War. During the Civil War, a New Jersey unit was instrumental in saving Washington, D.C., from Confederate capture. In World War II, New Jersey women flocked to war production factories and served in the armed forces, and a West Orange girl helped ferry Spitfire fighters in England. War came home to the coast in 1942 with the sinking of the SS "Resor" by a German submarine, but the state's citizens reacted by contributing everything they could to the war effort. Uncover these and other stories from New Jersey's hidden wartime history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph G Bilby, James M. Madden, Harry Ziegler
      </h2>
      
      <p class="authorDescription body article">Joseph Bilby served as lieutenant in the First Infantry Division in Vietnam and is the author/editor of more than three hundred articles and fourteen books on New Jersey and military history. He is a trustee of the New Jersey Civil War Heritage Association, publications editor for its 150th Anniversary Committee and assistant curator of the National Guard Militia Museum of New Jersey. James Madden has written for many Civil War publications, including the New Jersey Civil War Sesquicentennial Commission. He is a trustee of the New Jersey Civil War Heritage Association, the Historic Jersey City and Harsimus Cemetery, the Association of Professional Genealogists and the Jerramiah T. Healy Charitable Foundation for a Better Jersey City. Harry Ziegler worked for many years at the Asbury Park Press, New Jersey's second largest newspaper, rising from reporter to bureau chief, editor and managing editor of the paper. He is currently associate principal of Bishop George Ahr High School, in Edison, New Jersey, and has co-authored several books on New Jersey history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43e065e8